import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DigitalMarketingService } from 'app/core/digital-marketing/digital-marketing.service';
import { ContactService } from 'app/core/contact/contact.service';
import { InitialData } from './dm-creative.types';

@Injectable({
    providedIn: 'root'
})
export class DMCreativeDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _dmService: DigitalMarketingService, private router: Router, private user: ContactService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        let users = this.user.getContacts('user', null, null, null, null, null, null)
        let geographies = this._dmService.getDMCreativesInitial(route?.queryParams['campaign']).pipe(
            map((dmAdDevices) => ({
                dmAdDevices
            })
            ),
            catchError(err => {
                this._dmService.errorMessage = err.error.message ? err.error.message : "Something went wrong !";
                return of(new DefaultResponse().dmCreatives);
            })
        )
        let campaigns = this._dmService.getDMCampaignsInitial()
        let sources = [geographies, campaigns]

        if (localStorage.getItem('account_type')?.includes('admin')) {
            sources.push(users)
        }
        return forkJoin(sources)
    }

}

class DefaultResponse implements InitialData {
    dmCreatives: any = [];
}